module.exports = __webpack_public_path__ + "img/boy.f3b703ef.png";